/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

// Actions
import * as CompaniesActions from 'store/ducks/companies/actions';

// Types
import { ApplicationState } from 'store';
import { SelectedReportTypesInterface } from 'store/ducks/companies/types';

// Constants
import CONST_TRANSPORT_VOUCHER_COLLECTION from 'constants/transportVoucherCollectionReport';

// Styles
import useStyles from './paymentTypeFilter.styles';

const PaymentTypeFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const selectedPaymentType = useSelector(
    (state: ApplicationState) => state.companies.selectedPaymentType,
  );

  const handleStatus = (type: SelectedReportTypesInterface) => {
    const updated = [...selectedPaymentType];
    const index = selectedPaymentType.findIndex(({ KEY }) => KEY === type.KEY);

    if (index === -1) updated.push(type);
    else updated.splice(index, 1);

    dispatch(
      CompaniesActions.setSelectedPaymentType({
        selectedPaymentType: updated,
      }),
    );
  };

  return (
    <List dense>
      {CONST_TRANSPORT_VOUCHER_COLLECTION.PAYMENT_TYPE.map((type) => (
        <ListItem key={type.KEY} button>
          <ListItemText
            id={type.KEY}
            primary={type.VALUE}
            onClick={() => handleStatus(type)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Checkbox
              edge='end'
              name={type.VALUE}
              color='primary'
              onClick={() => handleStatus(type)}
              checked={
                !!selectedPaymentType.find(({ KEY }) => KEY === type.KEY)
              }
              inputProps={{ 'aria-labelledby': type.VALUE }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export { PaymentTypeFilter };
export default PaymentTypeFilter;
